<ion-app>
  <ion-router-outlet id="main-content" />
</ion-app>
